/* eslint-disable react/prop-types */
import React from 'react';
import { Row, Col } from 'react-flexbox-grid';

import { Header, Title, WhiteBackground } from './styled-components';

const PaperHeader = ({ title }) => (
  <WhiteBackground>
    <Header>
      <Row>
        <Col center="xs">
          <Title>{title}</Title>
        </Col>
      </Row>
    </Header>
  </WhiteBackground>
);

export default PaperHeader;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/PaperHeader/index.js